export default function filterTimestampReportData(allData, filters = {}) {
  if (!allData || allData.length === 0) return null

  let filteredData = allData

  if (filters.portalSelecionado) {
    filteredData = filteredData.filter(
      item => item.portal === filters.portalSelecionado,
    )
  }

  const groupedByBidding = {}
  filteredData.forEach(item => {
    if (!groupedByBidding[item.bidding_id]) {
      groupedByBidding[item.bidding_id] = []
    }
    groupedByBidding[item.bidding_id].push(item)
  })

  const phaseDurations = {}

  Object.values(groupedByBidding).forEach(biddingHistory => {
    const sortedHistory = biddingHistory.sort(
      (a, b) => new Date(a.history_Date) - new Date(b.history_Date),
    )

    for (let i = 1; i < sortedHistory.length; i += 1) {
      const phaseName = sortedHistory[i].phase_Name
      const durationInDays = (new Date(sortedHistory[i].history_Date) - new Date(sortedHistory[i - 1].history_Date))
      / (1000 * 60 * 60 * 24)

      if (!phaseDurations[phaseName]) phaseDurations[phaseName] = []
      phaseDurations[phaseName].push(durationInDays)
    }
  })

  const labels = Object.keys(phaseDurations)
  const averageDurations = labels.map(phase => {
    const durations = phaseDurations[phase]
    const total = durations.reduce((sum, value) => sum + value, 0)
    return parseFloat((total / durations.length).toFixed(2))
  })

  return {
    labels,
    datasets: [
      {
        label: 'Tempo médio por fase (dias)',
        backgroundColor: '#42A5F5',
        data: averageDurations,
      },
    ],
  }
}
